import { getStyle } from './getStyle';
import { getVSMEText } from '../../../../main/functions/vsme/getVSMEText';
import * as React from 'react';
import { WpdfText } from '../../pdf/WpdfText.';
import { WpdfView } from '../../pdf/WpdfView';

export function getVorwort(
    isPdf: boolean, getPageNum: (key: string, page: number, level: number) => void, data: any, jahr: number, standortTid: number
): JSX.Element {
    const keys = ['vorwort_absatz1', 'vorwort_absatz2', 'vorwort_absatz3', 'vorwort_absatz4'];

    return <WpdfView pdf={isPdf}>
        <WpdfText
            pdf={isPdf}
            style={{ ...getStyle('h1', isPdf), ...(isPdf && { marginTop: 0 }) }}
            getPageNum={(pageNumber: number) => typeof getPageNum === 'function' && getPageNum('Vorwort', pageNumber, 1)}
        >
            Vorwort
        </WpdfText>
        {keys.map((key: string, idx: number) =>
            <WpdfText key={`vorwort_${idx}`} style={getStyle('div')} pdf={isPdf}>
                {getVSMEText(key, data, jahr, standortTid)}
            </WpdfText>
        )}
    </WpdfView>;
}
